import './App.css';
import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import Certificates from './components/Certificates/Certificates';
import PlacementDashboard from './components/PlacementDashboard/PlacementDashboard';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from 'react-toastify';
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Routes>
          {/* Public routes with navbar and footer */}
          <Route path="/" element={
            <>
              <Navbar />
              <ScrollToTop />
              <Home />
              <Footer />
            </>
          } />
          <Route path="/project" element={
            <>
              <Navbar />
              <ScrollToTop />
              <Projects />
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Navbar />
              <ScrollToTop />
              <About />
              <Footer />
            </>
          } />
          <Route path="/resume" element={
            <>
              <Navbar />
              <ScrollToTop />
              <Resume />
              <Footer />
            </>
          } />
          <Route path="/certificates" element={
            <>
              <Navbar />
              <ScrollToTop />
              <Certificates />
              <Footer />
            </>
          } />

          {/* Placement dashboard route (no navbar/footer) */}
          <Route path="/admin/placement-dashboard" element={<PlacementDashboard />} />
        </Routes>
      </div>

      {/* Toast notifications */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  );
}

export default App;
